import SvgHelpOutline from '@hc-frontend/core-icons/kit/help-outline';
import { Checkbox, Tooltip } from '@hc-frontend/core-ui';

export type ContainerProps = {
  name: string;
  headline: string;
  content: string;
  tooltipText: string;
  tooltipClassName?: string;
};

export default function Container({
  name,
  headline,
  content,
  tooltipText,
  tooltipClassName,
}: ContainerProps) {
  const options = [
    {
      content,
      disabled: false,
      name,
      label: (
        <>
          <span className="px-2-8 font-bold">{headline}</span>
          <Tooltip
            triggerClassName="inline-block"
            title={tooltipText}
            className={tooltipClassName}
          >
            <SvgHelpOutline
              width="16px"
              height="16px"
              className="absolute bottom-[-2px]"
            />
          </Tooltip>
        </>
      ),
    },
  ];
  return (
    <div className="hc-box-layout rounded-sm border border-solid border-[#f8f8f8]">
      <Checkbox<'checkbox'>
        type="checkbox"
        options={options}
        inputContainerProps={{
          className: 'border-0',
        }}
      />
    </div>
  );
}
